<template>
  <div :class="wrapperClasses">
    <div :class="progressClasses" v-bind:style="progressWidth">{{ progress }}%</div>
  </div>
</template>

<script>
  /**
  * Just an empty component for quick copy and pasting purposes
  * Feel free to ignore
  */
  export default {
    name: 'ProgressBar',
    data () {
      return {}
    },

    props: {
      progress: {
        'type': Number,
        'default': 0
      }
    },

    computed: {

      success () {
        return true
      },

      inProgress () {
        return this.progress < 100
      },

      wrapperClasses () {
        return {
          'progress': true,
          'progress-striped': this.inProgress,
          'active': this.inProgress
        }
      },

      progressClasses () {
        return {
          'progress-bar': true,
          'progress-bar-primary': true
        }
      },

      progressWidth () {
        return {
          'width': `${this.progress}%`
        }
      }
    }
  }
</script>

<style scoped></style>
